<template>
  <md-boards class="md-primary hello-board" :md-controls="true">
    <md-board id="slide1" class="hello-board slide1">
      <md-layout md-column class="title">
        <span class="md-headline">CERTIFICAÇÃO DAS INSTALAÇÕES E EQUIPAMENTOS DO BLH</span>
        <span class="md-title">BEM VINDO</span>
      </md-layout>
      <img src="../assets/blh_logo.jpg" class="logo" />
      <!-- <md-layout md-column class="title">
        <span class="md-subheading">Este aplicativo foi designado para lhe auxiliar no processo de certificação</span>
      </md-layout> -->
    </md-board>
    <md-board class="hello-board slide2">
      <md-layout md-column>
        <span class="md-title">
          Para acessar a certificação, entre com os dados de usuario e senha.
        </span>
        <span class="md-caption">
          Estes dados são fornecido após o processo de credenciamento.
        </span>
        <span class="md-caption">
          Qualquer dúvida entre em contato através do site <a href="https://rblh.fiocruz.br">Rede Brasileira de Bancos de Leite Humano</a>
        </span>
        <md-button @click="login" class="login md-raised md-accent">Acessar o Processo de Certificação</md-button>
      </md-layout>
    </md-board>
  </md-boards>
</template>

<script>
export default {
  name: 'hello',
  methods: {
    login () {
      this.$router.push('/login')
    }
  }
}
</script>

<style>
.hello-board,
.md-boards-content {
  height: 100% !important;
}

.slide1 {
  top: 25%!important;
}

.slide2 {
  top: 25%!important;
}

.login {
  margin-top: 20px;
}

.title {
  text-align: center;
}

.logo {
  padding: 30px;
}
</style>



// WEBPACK FOOTER //
// Hello.vue?37cec551